export default "__VITE_PUBLIC_ASSET__987cacb9__"